export {
  BaseAvailabilityStatus,
  PlanUnitUnitType,
  BaseAllotmentStatus,
  BookingBookingStatus,
  ProductLayoutType
} from '@linktivity/ars-neo';

export const MONTHS = 3; // skytree calendar default months
export const AGENT_ID = 'skytree';

export { ALLOTMENT_STATUS, ALLOTMENT_THRESHOLD } from '@link/share/constants';
